export default __webpack_public_path__ + "1b7c8fc1f7ea785b7e1e6ddaf2285ab1.svg";